import React from "react";

import type { SuggestionPartType } from "./_part-types";

const hasContent = (part: SuggestionPartType): boolean => (part.content?.trim().length ?? 0) > 0;

export const SuggestionGroup: React.FC<{
	parts: ReadonlyArray<SuggestionPartType>;
	onSuggestionClick?: (text: string) => void;
}> = ({ parts, onSuggestionClick }) => {
	const visibleParts = parts.filter(hasContent);

	if (visibleParts.length === 0) {
		return null;
	}

	return (
		<div className="flex flex-col gap-1.5">
			<span className="font-semibold text-10 text-gray-500 uppercase tracking-wider">Suggestions</span>
			<ul className="flex flex-col gap-1">
				{visibleParts.map((part, index) => {
					const { content, part_id: partId } = part;

					if (content == null) {
						return null;
					}

					return (
						<li key={partId ?? `suggestion:${content}:${index}`}>
							<button
								className="flex cursor-pointer items-start gap-2 rounded-lg px-2 py-1.5 text-left text-gray-700 text-sm transition-colors hover:bg-gray-100 hover:text-primary-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/30 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
								onClick={() => onSuggestionClick?.(content)}
								type="button"
							>
								<span className="mt-1.5 size-1.5 shrink-0 rounded-full bg-primary-600" />
								{content}
							</button>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
